export const PRODUCTS_URL = '/api/v1/products'
